import { render } from "./InvoiceCheck.vue?vue&type=template&id=c2bfad3e"
import script from "./InvoiceCheck.vue?vue&type=script&lang=js"
export * from "./InvoiceCheck.vue?vue&type=script&lang=js"

import exportComponent from "D:\\cwzl\\four-cw-net\\front-end\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__